export default "__VITE_ASSET__DFsvp5wQ__"